import React from "react";

export default function DownloadTheAppFooter() {
  return (
    <div className="bg-[#6F4AD4] relative w-full lg:w-96 lg:right-0 flex flex-col -bottom-0 z-50 justify-between py-6 px-5 mx-auto mt-12 lg:mb-8 ">
      <span className="text-white text-lg font-semibold mb-1">
        Snacktime is better on the app
      </span>
      <span className="text-white text-sm mb-4 w-[90%]">
        Check out the mobile app for the full Snacktime experience 👍
      </span>
      <div>
        <a
          href={process.env.NEXT_PUBLIC_APP_DOWNLOAD_URL}
          target="_blank"
          className="rounded-3xl text-xs font-semibold bg-gray-200 px-3 py-1.5"
          rel="noreferrer"
        >
          Switch to the app
        </a>
      </div>
    </div>
  );
}
